import { render, staticRenderFns } from "./import-with-rule.vue?vue&type=template&id=4784c960&scoped=true&"
import script from "./import-with-rule.vue?vue&type=script&lang=js&"
export * from "./import-with-rule.vue?vue&type=script&lang=js&"
import style0 from "./import-with-rule.vue?vue&type=style&index=0&id=4784c960&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784c960",
  null
  
)

export default component.exports